import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { user, userProfile, loading } = useAuth();
  const location = useLocation();
  
  // Check if debug mode is active
  const isDebugMode = new URLSearchParams(location.search)?.get('debug') === '1';
  const isAdminInsertVetrina = location?.pathname === '/admin-insert-vetrina';

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Skip redirect if we're on admin-insert-vetrina with debug=1
  if (isAdminInsertVetrina && isDebugMode) {
    return children;
  }

  if (!user) {
    return <Navigate to="/public-vetrine" replace />;
  }

  if (allowedRoles?.length > 0 && !allowedRoles?.includes(userProfile?.role)) {
    return <Navigate to="/public-vetrine" replace />;
  }

  return children;
};

export default ProtectedRoute;